import React__default, { useState } from 'react';
import { format } from 'date-fns';
import withChat from '../../containers/Provider/withChat.js';
import { uniq } from 'lodash';
import classnames from 'classnames';
import { MessageChannel } from '@deal/chat-firebase-client';
import Avatar from '../Avatar/index.js';
import { Link } from 'react-router-dom';
import copy from 'copy-text-to-clipboard';
import styles from './styles.css.js';

function formatChannel(channel) {
  switch (channel) {
    case MessageChannel.SMS:
      return 'SMS';

    case MessageChannel.EMAIL:
      return 'Email';

    case MessageChannel.FACEBOOK:
      return 'Facebook Messenger';
  }
}

var MessageGroup = function MessageGroup(_a) {
  var _b, _c, _d;

  var sender = _a.sender,
      sentAt = _a.sentAt,
      channels = _a.channels,
      children = _a.children,
      persona = _a.persona,
      type = _a.type,
      metadata = _a.metadata,
      chatClient = _a.chatClient,
      impersonating = _a.impersonating;

  var _e = useState(false),
      copied = _e[0],
      setCopied = _e[1];

  var client = chatClient;
  var myself = client && client.myself;
  var isTeammate = !!(sender && myself && (sender.type === 'BUSINESS_USER' && myself.type === 'BUSINESS_USER' && myself !== sender || sender.type === 'SUPPORT' && myself.type === 'OPERATOR' && myself !== sender));
  var uniqChannels = uniq(channels).filter(function (c) {
    return c !== null;
  });
  var formattedChannels = uniqChannels.length ? "via " + uniqChannels.map(formatChannel).join(' and ') : null; // For inbound messages, we show what channel(s) the messages were sent from.
  // For outbound messages, we show whether the message was an auto message (except for consumers).

  var formattedMetadata = formattedChannels;
  var labelAsAutoMessage = false;

  if (metadata && metadata.type === 'auto-message' && myself && myself.type !== 'USER' && myself.type !== 'GUEST') {
    labelAsAutoMessage = true;

    if (impersonating) {
      formattedMetadata = React__default.createElement("span", {
        title: metadata.campaign,
        onDoubleClick: function onDoubleClick() {
          if (metadata.campaign) {
            copy(metadata.campaign);
            setCopied(true);
            setTimeout(function () {
              setCopied(false);
            }, 1500);
          }
        }
      }, copied ? React__default.createElement("em", null, "copied to clipboard") : 'via auto message');
    } else {
      formattedMetadata = 'via auto message';
    }
  }

  var isSenderClickable = sender && sender.vanityId;
  return React__default.createElement("li", {
    className: classnames(styles.group, styles.flat, (_b = {}, _b[styles.teammate] = isTeammate && type === 'message', _b[styles.automessage] = labelAsAutoMessage, _b))
  }, React__default.createElement("div", {
    className: styles.columns
  }, sender && (isSenderClickable ? React__default.createElement(Link, {
    to: "/experts/" + sender.vanityId
  }, React__default.createElement(Avatar, {
    sender: sender,
    size: "medium",
    className: classnames(styles.avatar, (_c = {}, _c[styles.clickable] = isSenderClickable, _c))
  })) : React__default.createElement(Avatar, {
    sender: sender,
    size: "medium",
    className: classnames(styles.avatar, (_d = {}, _d[styles.clickable] = isSenderClickable, _d))
  })), React__default.createElement("div", {
    className: styles.messages
  }, children, sender && (isSenderClickable ? React__default.createElement(Link, {
    to: "/experts/" + sender.vanityId
  }, React__default.createElement("span", {
    className: classnames(styles.sender)
  }, sender && sender.displayName, sentAt && React__default.createElement("time", {
    className: styles.sentAt,
    dateTime: sentAt.toISOString()
  }, format(sentAt, 'h:mm aaaa')), React__default.createElement("span", {
    className: styles.metadata
  }, formattedMetadata))) : React__default.createElement("span", {
    className: classnames(styles.sender)
  }, sender && sender.displayName, " ", persona && "(" + persona + ")", sentAt && React__default.createElement("time", {
    className: styles.sentAt,
    dateTime: sentAt.toISOString()
  }, format(sentAt, 'h:mm aaaa')), React__default.createElement("span", {
    className: styles.metadata
  }, formattedMetadata))))));
};

var MessageGroup$1 = withChat(MessageGroup);

export default MessageGroup$1;
//# sourceMappingURL=index.js.map
